module.exports = "<ul class=\"group-list-container list-group\" :style=\"isVisible ? '' : 'display:none'\">\r\n    <tree-item ref=\"treeItem\" v-for=\"group in groups\" :group=\"group\" :options=\"options\" :parentGroupCode=\"parentGroupCode\"/>\r\n</ul>"


//////////////////
// WEBPACK FOOTER
// ./src/views/tree/treeList.html
// module id = 23
// module chunks = 0